import { formatMoney, formatMoneyFull } from "@/lib/money"

function isoToDate(iso: string): Date {
  return new Date(iso + "T00:00:00")
}

/** "Jan 1 – Sep 3, 2026" (year once when both ends share it). */
export function formatRange(from: string, to: string): string {
  const a = isoToDate(from)
  const b = isoToDate(to)
  const md = (d: Date) => d.toLocaleDateString("en-US", { month: "short", day: "numeric" })
  const mdy = (d: Date) => d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })
  return a.getFullYear() === b.getFullYear() ? `${md(a)} – ${mdy(b)}` : `${mdy(a)} – ${mdy(b)}`
}

/** "Sep 7, 2026" */
export function formatDate(iso: string): string {
  return isoToDate(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })
}

/** Compact cell / axis value: "₫25.3B". */
export function formatValue(value: number, currency: string | null): string {
  return formatMoney(value, currency)
}

/** Full value for tooltips: "25,310,000,000". */
export function formatValueFull(value: number, currency: string | null): string {
  return formatMoneyFull(value, currency)
}

/** Units sold of one product: "1 unit", "1,234 units". */
export function formatUnits(quantity: number): string {
  return `${quantity.toLocaleString("en-US")} ${quantity === 1 ? "unit" : "units"}`
}
